import React from 'react';

import cs from 'classnames';
import { addYears, subYears } from 'date-fns';
import { DayPickerProps, DayPicker as ReactDayPicker, Weekday } from 'react-day-picker';
import BaseClassNames from 'react-day-picker/src/style.module.css';

import s from './index.module.css';

export const DatePicker = function ({
  components = {},
  classNames = {},
  startMonth,
  endMonth,
  ...rest
}: DayPickerProps) {
  const defaultStartmonth = startMonth ?? subYears(new Date(), 3);
  const defaultEndMonth = endMonth ?? addYears(new Date(), 10);

  const renderWeekday = React.useCallback<typeof Weekday>((props) => {
    const label = props['aria-label'];
    if (!label) return <Weekday {...props} />;
    return <Weekday {...props}>{label.toUpperCase().slice(0, 3)}</Weekday>;
  }, []);

  return (
    <div className={s.wrapper}>
      <ReactDayPicker
        captionLayout="dropdown"
        showOutsideDays
        startMonth={defaultStartmonth}
        endMonth={defaultEndMonth}
        components={{ Weekday: renderWeekday, ...components }}
        {...rest}
        defaultMonth={rest.defaultMonth}
        classNames={{
          ...BaseClassNames,
          root: cs(BaseClassNames.root, s.root, classNames.root),
          selected: cs(BaseClassNames.selected, s.selected, classNames.selected),
          month_grid: cs(BaseClassNames.month_grid, s.month_grid, classNames.month_grid),
          day: cs(BaseClassNames.day, s.day, classNames.day),
          day_button: cs(BaseClassNames.day_button, s.day_button, classNames.day_button),
          range_middle: cs(BaseClassNames.range_middle, s.range_middle, classNames.range_middle),
          range_start: cs(BaseClassNames.range_start, s.range_start, classNames.range_start),
          range_end: cs(BaseClassNames.range_end, s.range_end, classNames.range_end),
          month_caption: cs(BaseClassNames.month_caption, s.month_caption, classNames.month_caption),
          nav: cs(BaseClassNames.nav, s.nav, classNames.nav),
          dropdown_root: cs(BaseClassNames.dropdown_root, s.dropdown_root, classNames.dropdown_root),
          chevron: cs(BaseClassNames.chevron, s.chevron, classNames.chevron),
          week: cs(BaseClassNames.week, classNames.week),
          weekday: cs(BaseClassNames.weekday, classNames.weekday),
        }}
      />
    </div>
  );
};
